import React from 'react'
import Filter from './filter'
import Summary from './summary'
import Totals from './totals'
import {
    getMovementsSummary,
    getMovementsExcel,
} from '../../../helpers/restHelpers'
import routes from '../../router/routes'
import Loader from '../../loaders'

class Component extends React.Component {
    state = { summaryItems: null }

    handleFilterSubmit = (dateFrom, dateTo) => {
        this.setState({ loader: true })
        getMovementsSummary(dateFrom, dateTo)
            .then((x) => this.setState({ summaryItems: x, dateFrom, dateTo }))
            .catch((x) =>
                window.showDialog(x, () =>
                    this.props.history.push(routes.orders.path)
                )
            )
            .finally(() => this.setState({ loader: false }))
    }

    handlePrint = () => {
        const { dateFrom, dateTo } = this.state
        this.setState({ loader: true })
        getMovementsExcel(dateFrom, dateTo)
            .catch((x) =>
                window.showDialog(x, () =>
                    this.props.history.push(routes.orders.path)
                )
            )
            .finally(() => this.setState({ loader: false }))
    }

    render() {
        const { handlePrint, handleFilterSubmit } = this
        const { loader, summaryItems, dateFrom, dateTo } = this.state

        return (
            <>
                {loader ? <Loader /> : null}

                <Filter
                    handleSubmit={handleFilterSubmit}
                    dateFrom={dateFrom}
                    dateTo={dateTo}
                />
                <Totals summaryItems={summaryItems} />
                <br />
                <Summary
                    summaryItems={summaryItems}
                    handlePrint={handlePrint}
                />
            </>
        )
    }
}

export default Component
